module.exports = __webpack_public_path__ + "ec4d6e7770ac16401e90a3acb5956abf.svg";